import { AppointmentSlot } from 'vl-common/src/types';
import { groupBy } from 'lodash';
import { DateTime } from 'luxon';
import { getF2FConsultants, getRandoxClinics } from 'vl-common/src/schemas';
import { RandoxSlot } from 'vl-common/src/types/Appointments';

export type ConsultantSlot = getF2FConsultants.Response['consultantSlots'][0];
export type RandoxSlots = getRandoxClinics.Response['closestClinics'];

/** Convert randox clinic slot to local date time */
export const parseRandoxClinicSlotUtc = (date: string, time: string): DateTime => {
  let dt = DateTime.fromFormat(`${date} ${time}`, 'dd/MM/yyyy HH:mm', { zone: 'utc' });
  if (!dt.isValid) dt = DateTime.fromFormat(`${date} ${time}`, 'dd/MM/yyyy hh:mm', { zone: 'utc' });
  return dt;
};

export const transformRandoxSlots = (slots: RandoxSlots[0]['clinicSlots']): RandoxSlot[] =>
  slots?.map(({ id, date, duration, time }) => {
    const start = parseRandoxClinicSlotUtc(date, time).toJSDate();

    const length = Number(duration);
    const end = DateTime.fromJSDate(start).plus({ minutes: length }).toJSDate();

    return { slotId: id, start, end, length };
  });

export const transformF2FSlots = (slots: ConsultantSlot['slots']) =>
  slots?.map(({ slotId, slotDate, slotDuration, slotTime }) => {
    const length = Number(slotDuration);
    const start = DateTime.fromISO(`${slotDate}T${slotTime}Z`).toJSDate();
    const end = DateTime.fromJSDate(start).plus({ minutes: length }).toJSDate();

    return { slotId, start, end, length };
  });

export const groupSlotsByWeek = (slots: AppointmentSlot[]) =>
  groupBy(slots, (slot) => {
    const { year, weekNumber } = DateTime.fromJSDate(slot.start);

    return `${year}-${weekNumber}`;
  });

export const groupSlotsByWeekSorted = (slots: AppointmentSlot[]) => {
  const groups = groupSlotsByWeek(slots);

  return Object.keys(groups)
    .sort((a, b) => {
      const [yearA, weekA] = a.split('-').map(Number);
      const [yearB, weekB] = b.split('-').map(Number);

      return yearA - yearB || weekA - weekB;
    })
    .map((key) => groups[key]);
};

export const formatDate = (dob: Date) => {
  if (dob) {
    return `${dob.getFullYear()}-${(dob.getMonth() + 1).toString().padStart(2, '0')}-${dob
      .getDate()
      .toString()
      .padStart(2, '0')}`;
  }
  return '';
};
